import { Fragment } from 'react';
import PropTypes from 'prop-types';

import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import { SitemapNavigation } from './SitemapNavigation';
import { SitemapAlphaNavigation } from './SitemapAlphaNavigation';
import { SitemapIndexesNavigation } from './SitemapIndexesNavigation';

import { ALPHA_TITLE_ID, URI_SEGMENT_DEALER } from '../constants/sitemapConstants';

import styles from '../styles/sitemap.scss';

function displayItemsList(items) {
    return (
        <ul className="rowFlex cf" data-tn="sitemap-full-list">
            {items.map((item, i) => (
                <li className="colXs6 colLg4" key={`${item.linkUrl}${i}`}>
                    <Link
                        href={item.linkUrl}
                        className={styles.link}
                        data-tn={`sitemap-list-link-${item.label}`}
                        data-link
                    >
                        {item.title}
                    </Link>
                </li>
            ))}
        </ul>
    );
}

function showResultsCounter(sitemapLinks) {
    const { items, resultsHeader } = sitemapLinks;
    return (
        <h2 className={styles.sitemapResultsHeader} data-tn="sitemap-results-header">
            <FormattedMessage
                id="sitemap.countingResults"
                defaultMessage="Showing {count, plural, one {# result} other {# results}} for {resultsHeader}"
                values={{
                    count: items.length,
                    resultsHeader,
                }}
            />
        </h2>
    );
}
export const SitemapValueTypeComponent = ({ sitemap, vertical, filterType, filterTypeValue }) => {
    const sitemapLinks = sitemap?.sitemapLinks?.[0] || {};
    const hasChildren = !!sitemapLinks.items?.[0]?.items;
    const isDealersPage = sitemapLinks.linksType === URI_SEGMENT_DEALER;

    return (
        <div className={styles.sitemapWrapper}>
            <h1 className={styles.sitemapMainHeader}>{sitemapLinks.headerText}</h1>
            <SitemapNavigation vertical={vertical} filterType={filterType} />
            {hasChildren ? (
                <Fragment>
                    <SitemapAlphaNavigation items={sitemapLinks.items} />
                    {sitemapLinks.items.map(item => (
                        <Fragment key={`${ALPHA_TITLE_ID}${item.title}`}>
                            <h2 id={`${ALPHA_TITLE_ID}${item.title}`} data-grouped-header>
                                {item.title.toUpperCase()}
                            </h2>
                            {displayItemsList(item.items)}
                        </Fragment>
                    ))}
                </Fragment>
            ) : (
                <Fragment>
                    {isDealersPage && (
                        <SitemapIndexesNavigation vertical={vertical} filterType={filterType} />
                    )}
                    {!isDealersPage && filterTypeValue && showResultsCounter(sitemapLinks)}
                    {displayItemsList(sitemapLinks.items)}
                </Fragment>
            )}
        </div>
    );
};
/*


*/
SitemapValueTypeComponent.propTypes = {
    vertical: PropTypes.string.isRequired,
    filterType: PropTypes.string.isRequired,
    sitemap: PropTypes.object.isRequired,
    filterTypeValue: PropTypes.string,
    viewer: PropTypes.object.isRequired,
};

export const SitemapValueType = createFragmentContainer(SitemapValueTypeComponent, {
    sitemap: graphql`
        fragment SitemapValueType_sitemap on Sitemap {
            sitemapLinks {
                headerText
                linksType
                resultsHeader
                items {
                    title
                    label
                    linkUrl
                    items {
                        label
                        title
                        linkUrl
                    }
                }
            }
        }
    `,
});
